/**
 * Directive implements sticky footer behavior
 *
 * <div gw-pl-sticky-footer-wrapper class="footer-sticky">
 *     <div gw-pl-sticky-footer class="footer-sticky"></div>
 * </div>
 *
 * gw-pl-sticky-footer-wrapper is used to measure a top position
 * gw-pl-sticky-footer is used to assign a "translate" property
 */
define([
    '../StickyCommonUtils'
], (stickyUtils)=> {
    return ['phoneMediaBreakpoint', (phoneMediaBreakpoint)=> {
        return {
            'restrict': 'A',
            'link': ($scope, element)=> {
                // VARS
                const $footerStickyWrapper = $(element);
                const $footerSticky = $footerStickyWrapper.find('[gw-pl-sticky-footer]');
                const $scrollElement = $(document);

                const $window = $(window);

                // FIXED POSITION
                function refreshPosition() {
                    const stickyFooterTopPos = $footerStickyWrapper.offset().top;
                    const windowBottom = $window.scrollTop() + $window.height();
                    const footerStickyHeight = $footerStickyWrapper.outerHeight();

                    if (windowBottom > (stickyFooterTopPos + footerStickyHeight)) {
                        resetPositionToDefault();
                        return;
                    }

                    const translateY = windowBottom - stickyFooterTopPos - footerStickyHeight;
                    $footerSticky.css('transform', `translateY(${translateY}px)`);
                }

                function resetPositionToDefault() {
                    $footerSticky.css('transform', '');
                }

                // COMMON STICKY BEHAVIOR
                stickyUtils = stickyUtils({
                    $scope,
                    $scrollElement,
                    refreshPosition,
                    resetPositionToDefault,
                    phoneMediaBreakpoint
                });
            }
        };
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/pagestructure/directives/StickyFooterDirective.js